import { EncryptStorage } from 'encrypt-storage';

// const encryptStorage = new EncryptStorage(process.env.SECRET_KEY, options);
export const encryptStorage = new EncryptStorage('fgc-storage');